import { SocialLanguageField } from '@app/modules/social-export/components/inputs/SocialLanguageField';
import { PlatformSettingsFormShell } from '@app/modules/social-export/components/settings/PlatformSettingsFormShell';
import { BaseSettingsFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { socialExport } from '@mi-front/api-clients';
import { Box, Grid } from '@mui/material';
import { SwitchElement } from 'react-hook-form-mui';
import { defineMessage, useIntl } from 'react-intl';
import { z } from 'zod';
import { DailymotionCategoryField } from './DailymotionCategoryField';

export const dailymotionSettingsSchema = z.object({
  channel: z
    .union([z.nativeEnum(socialExport.DailymotionSettingsDtoChannelEnum), z.literal('')])
    .nullable()
    .optional()
    .transform((val) => (val === '' ? null : val)),
  forKids: z.boolean().nullable().optional(),
  private: z.boolean().nullable().optional(),
  language: z
    .string()
    .nullable()
    .optional()
    .transform((val) => (val === '' ? null : val)),
});

const forKidsMessage = defineMessage({
  id: 'socialExport.form.forKids',
  defaultMessage: 'Contenido apto para niños',
});

const uploadAsPrivateMessage = defineMessage({
  id: 'socialExport.form.uploadAsPrivate',
  defaultMessage: 'Cargar como video privado',
});

export function DailymotionSettingsForm({
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.DailymotionSettingsDto>) {
  const { $t } = useIntl();
  return (
    <PlatformSettingsFormShell
      values={{
        channel: defaultSettings.channel,
        forKids: defaultSettings.forKids,
        private: defaultSettings.private,
        language: defaultSettings.language,
      }}
      schema={dailymotionSettingsSchema}
      onSuccess={async (formData) => {
        await onUpdate({
          channel: formData.channel,
          forKids: formData.forKids,
          private: formData.private,
          language: formData.language,
        });
      }}
    >
      <Grid container>
        <Grid item md={4}>
          <DailymotionCategoryField />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={4}>
          <SocialLanguageField />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={4}>
          <Box display="flex" flexDirection="column" alignItems="flex-start" gap={2}>
            <SwitchElement name="forKids" label={$t(forKidsMessage)} color="primary" />
            <SwitchElement name="private" label={$t(uploadAsPrivateMessage)} color="primary" />
          </Box>
        </Grid>
      </Grid>
    </PlatformSettingsFormShell>
  );
}
